import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material"
import { useFormik } from "formik"


const EmailConfirmationDialog = ({ open, onClose, onSubmit, data }) => {

    const { values, handleChange, handleSubmit, errors, touched } = useFormik({
        initialValues: {
            data,
            code: "",
        },
        enableReinitialize: true,
        onSubmit,
    })

    return <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle>
            Подтверждение электронной почты
        </DialogTitle>
        <DialogContent>
            <Typography sx={{ mb: 2 }}>На адрес {data?.email} был выслан код подтверждения</Typography>
            <TextField
                id="code"
                name="code"
                label="Код подтверждения"
                value={values.code}
                onChange={handleChange}
                fullWidth
                error={touched.code && !!errors.code}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={handleSubmit}>Завершить регистрацию</Button>
        </DialogActions>
    </Dialog>
}

export default EmailConfirmationDialog